var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicesBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1140,
    height: 910,
    viewBox: "0 0 1140 810",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.3664 479.738C61.6285 423.762 95.1573 354.171 158.09 343.325L449.88 293.038C461.927 290.962 473.492 286.694 484 280.447L838.16 69.885C884.455 42.3611 944.377 59.7947 968.68 107.858L1065.75 299.831C1076.9 321.881 1078.82 347.462 1071.08 370.928L1011.79 550.681C1001.74 581.147 976.699 604.283 945.535 611.895L326.513 763.083C285.65 773.063 243.176 754.373 222.929 717.502L92.3664 479.738Z",
    fill: "#F7E3E3",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 620.246 796.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 620.246 780.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 620.246 764.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 604.246 796.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 604.246 780.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 604.246 764.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 588.246 796.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 588.246 780.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 588.246 764.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 572.246 796.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 572.246 780.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 572.246 764.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 556.246 796.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 556.246 780.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 556.246 764.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 540.246 796.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 540.246 780.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 540.246 764.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 524.246 796.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 524.246 780.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 524.246 764.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 508.246 796.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 508.246 780.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 508.246 764.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 492.246 796.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 492.246 780.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 492.246 764.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 620.246 748.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 620.246 732.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 620.246 716.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 588.246 748.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 588.246 732.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 588.246 716.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 604.246 748.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 604.246 732.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 604.246 716.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 572.246 748.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 572.246 732.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 572.246 716.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 556.246 748.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 556.246 732.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 556.246 716.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 540.246 748.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 540.246 732.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 540.246 716.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 524.246 748.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 524.246 732.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 524.246 716.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 508.246 748.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 508.246 732.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 508.246 716.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 492.246 748.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 492.246 732.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 492.246 716.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 588.246 701.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 588.246 685.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 588.246 669.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 620.246 701.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 620.246 685.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 620.246 669.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 604.246 701.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 604.246 685.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 604.246 669.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 572.246 701.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 572.246 685.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 572.246 669.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 556.246 701.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 556.246 685.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 556.246 669.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 540.246 701.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 540.246 685.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 540.246 669.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 524.246 701.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 524.246 685.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 524.246 669.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 508.246 701.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 508.246 685.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 508.246 669.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 492.246 701.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 492.246 685.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 492.246 669.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 476.246 796.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 476.246 780.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 476.246 764.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 460.246 796.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 460.246 780.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 460.246 764.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 444.246 796.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 444.246 780.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 444.246 764.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 428.246 796.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 428.246 780.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 428.246 764.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 412.246 796.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 412.246 780.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 412.246 764.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 396.246 796.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 396.246 780.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 396.246 764.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 380.246 796.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 380.246 780.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 380.246 764.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 364.246 796.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 364.246 780.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 364.246 764.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 348.246 796.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 348.246 780.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 348.246 764.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 476.246 748.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 476.246 732.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 476.246 716.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 444.246 748.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 444.246 732.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 444.246 716.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 460.246 748.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 460.246 732.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 460.246 716.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 428.246 748.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 428.246 732.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 428.246 716.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 412.246 748.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 412.246 732.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 412.246 716.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 396.246 748.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 396.246 732.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 396.246 716.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 380.246 748.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 380.246 732.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 380.246 716.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 364.246 748.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 364.246 732.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 364.246 716.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 348.246 748.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 348.246 732.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 348.246 716.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 444.246 701.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 444.246 685.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 444.246 669.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 476.246 701.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 476.246 685.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 476.246 669.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 460.246 701.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 460.246 685.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 460.246 669.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 428.246 701.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 428.246 685.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 428.246 669.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 412.246 701.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 412.246 685.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 412.246 669.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 396.246 701.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 396.246 685.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 396.246 669.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 380.246 701.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 380.246 685.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 380.246 669.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 364.246 701.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 364.246 685.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 364.246 669.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 348.246 701.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 348.246 685.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 348.246 669.5)",
    stroke: "#D12E29",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesBackground);
export default __webpack_public_path__ + "static/media/services_background.dab44ef8ef4b73e46b3725a9eae9267a.svg";
export { ForwardRef as ReactComponent };